export default (value, language = 'pt-br') => {
  if (language === 'pt_BR') {
    language = 'pt-br'
  } else if (language === 'en_US') {
    language = 'en'
  } else if (language === 'es_ES') {
    language = 'es'
  }
  const date = new Date(value)
  return date.toLocaleDateString(
    [language],
    {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
  ).replace('Invalid Date', '')
}



// WEBPACK FOOTER //
// ./src/filters/date.js